var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-empty-state',{staticClass:"md-accent",attrs:{"md-icon":"wifi_off","md-label":"No se encontró conexión a internet","md-description":"Para poder acceder a este módulo es necesario una conexión a internet"}})}
var staticRenderFns = []

export { render, staticRenderFns }